module.exports = __webpack_public_path__ + "static/media/me2.3e0177d4.jpeg";